import axiosInstance from './api/axiosInstance';

export interface WishlistItem {
  _id?: string;
  itemType: 'product' | 'service';
  itemId: string;
  name: string;
  price: number;
  currency: string;
  image?: string;
  vendorId: string;
  vendorName?: string;
  category?: string;
  addedAt?: string;
}

export interface Wishlist {
  _id?: string;
  user: string;
  items: WishlistItem[];
  itemCount?: number;
  createdAt?: string;
  updatedAt?: string;
}

class WishlistService {
  /**
   * Get user's wishlist
   */
  async getWishlist(): Promise<{ success: boolean; data: Wishlist }> {
    const response = await axiosInstance.get('/wishlist');
    return response.data;
  }

  /**
   * Add product to wishlist
   */
  async addProduct(productId: string): Promise<{ success: boolean; data: Wishlist; message: string }> {
    const response = await axiosInstance.post(`/wishlist/add/${productId}`);
    return response.data;
  }

  /**
   * Add service to wishlist
   */
  async addService(serviceId: string): Promise<{ success: boolean; data: Wishlist; message: string }> {
    const response = await axiosInstance.post(`/wishlist/add-service/${serviceId}`);
    return response.data;
  }

  /**
   * Remove item from wishlist
   */
  async removeItem(itemId: string): Promise<{ success: boolean; data: Wishlist; message: string }> {
    const response = await axiosInstance.delete(`/wishlist/remove/${itemId}`);
    return response.data;
  }

  /**
   * Move item from wishlist to cart
   */
  async moveToCart(itemId: string): Promise<{ success: boolean; data: { wishlist: Wishlist; cart: any }; message: string }> {
    const response = await axiosInstance.post(`/wishlist/move-to-cart/${itemId}`);
    return response.data;
  }
}

export const wishlistService = new WishlistService();
